export const API = {
  BASE_URL: "https://newstrial-api.bairuhatech.com/api/",
  // BASE_URL: "http://localhost:8073/api/",
  CDN_URL: "https://dwzdy3b3kx24e.cloudfront.net/",
  EPAPER: "ePaper",

  CREATE_USER: "web-users",
  USER_LOGIN: "webUserLogin",
  SUBSCRIBE: "createPyment",
  CHECK_USER_SUBSCRIPTION: "checkUserSubscription",
};
